import { createReducer, on } from '@ngrx/store';
import * as fromAppSettingsConfigActions from '../actions/app-settings-config.actions';
import { IAppSettingsInvalidCharactersItem } from '../models/app-settings-invalid-characters-item.model';
import { IAppSettingsAddressAutocompletion } from '../models/app-settings-address-autocompletion.model';
import { IAppSettingsMockIban } from '../models/app-settings-mock-iban.model';


export interface AppSettingsConfigState {

  invalidCharactersConfig?: IAppSettingsInvalidCharactersItem;
  addressAutocompletion?: IAppSettingsAddressAutocompletion;
  mockIban?: IAppSettingsMockIban;
  streetnameAllowedCharacters?: string;
  housenoAllowedCharacters?: string;
  showCheckboxForSwapSimCardType?: boolean;
  choosePaymentMethod?: boolean;
  paymentMethods?: { [key: string]: { enabled: boolean, sort: number, minAge18: boolean } };
  demoButton?: boolean;
  show3rdSalutation?: boolean; // EB-18006
  showNewsletterSection?: boolean; // EB-19199
  enableAddressCheckOverruling?: boolean;
  properties?: { [key: string]: {provide: boolean, value: boolean } };
  customerProperties?: { [key: string]: {provide: boolean, value: boolean } };
  consentsVersion?: string;
  customerConsents?: { [key: string]: { consentId: string, consentName: string, consentVersion: string, featureType: string, feature: string } };
  clientVersion?: string;
  tariffOptionCategories?: string[];
  blacklistNames?: string[];
  blacklistMSISDN?: string[];
  whiteListCharacters?: string;
}


export const initialAppSettingsConfigState: AppSettingsConfigState = {
  invalidCharactersConfig: null,
  addressAutocompletion: null,
  mockIban: null,
  showCheckboxForSwapSimCardType: null,
  choosePaymentMethod: null,
  paymentMethods: {},
  demoButton: null,
  show3rdSalutation: null, // EB-18006
  showNewsletterSection: null, // EB-19199
  enableAddressCheckOverruling: null,
  properties: {},
  customerProperties: {},
  consentsVersion: null,
  customerConsents: {},
  clientVersion: null,
  tariffOptionCategories: [],
  blacklistNames: [],
  blacklistMSISDN: [],
  whiteListCharacters: null
};

export const reducer = createReducer(
  initialAppSettingsConfigState,
  on(fromAppSettingsConfigActions.setAppSettingsConfig, (state, { data }) => ({
    ...data
  })),
  on(fromAppSettingsConfigActions.deleteAppSettingsConfig, state => ({
    ...initialAppSettingsConfigState
  }))
);
